var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-container" },
    [
      _c("v-select", {
        staticClass: "form-control",
        attrs: {
          reduce: _vm.reduceSelectedOption,
          options: _vm.filterTypeOptions,
          clearable: false,
          autocomplete: "",
          disabled: !_vm.canEdit
        },
        model: {
          value: _vm.filterType,
          callback: function($$v) {
            _vm.filterType = $$v
          },
          expression: "filterType"
        }
      }),
      _vm._v(" "),
      _c("v-select", {
        ref: "question",
        staticClass: "form-control",
        attrs: {
          options: _vm.questionOptions,
          clearable: false,
          disabled: !_vm.canEdit || !_vm.canSelectValue,
          multiple: "",
          autocomplete: ""
        },
        on: { search: _vm.fetchOptions },
        model: {
          value: _vm.questionValue,
          callback: function($$v) {
            _vm.questionValue = $$v
          },
          expression: "questionValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }